module.exports = __webpack_public_path__ + "static/integration-0abaa97359ddd2beff42ae72c3fbb1a1.gif";